<template>
    <div class="page">
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="登录账号">
                <el-input v-model="queryForm.userName" placeholder="请填写登录账号" style="width: 175px"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
                <el-input v-model="queryForm.userMobile" placeholder="请填写手机号码" style="width: 175px"></el-input>
            </el-form-item>
            <el-form-item label="用户昵称">
                <el-input v-model="queryForm.userNickname" placeholder="请填写用户昵称" style="width: 175px"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
                <el-input v-model="queryForm.userRealname" placeholder="请填写真实姓名" style="width: 175px"></el-input>
            </el-form-item>
            <el-form-item label="货币类型">
                <el-select placeholder="请选择货币类型" clearable v-model="queryForm.currencyType" style="width: 175px">
                    <el-option v-for="item in currencyTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="记录状态">
                <el-select placeholder="请选择记录状态" clearable v-model="queryForm.recordStatus" style="width: 180px">
                    <el-option v-for="status in recordStatusList" :key="status.key" :label="status.value" :value="status.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作时间">
                <el-date-picker
                    style="width: 180px"
                    v-model="timeRange"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="searchRecordList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group" style="display: flex">
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="false"
                    >删除</el-button
                    >
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span title="导出数据" class="icon-box" @click="exportRecharge">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span>
                    <span class="icon-box">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="rechargeList"
                width="100%"
                row-key="id"
                size="small"
                height="100%"
                @selection-change="handleSelectionChange"
                :default-expand-all="true"
            >
                <el-table-column align="center" type="selection" width="50px"> </el-table-column>
                <el-table-column align="center" label="用户" width="180px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.user">
                            <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                            <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                            <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                            <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="充值金额" width="100px">
                    <template slot-scope="scope">
                        <div>
                            {{scope.row.money}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="货币类型" width="100px">
                    <template slot-scope="scope">
                        {{ getCurrencyType(scope.row.currencyType) }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="收款账户" width="230px">
                    <template slot-scope="scope" v-if='scope.row.recharge != null'>
                        <div v-if='scope.row.recharge.receiveInfo.slice(0,4) != "http"'>
                            <div style="text-align: left">收款银行：{{ scope.row.recharge.receiveInfo.split('-')[0] }}</div>
                            <div style="text-align: left">收款账户：{{ scope.row.recharge.receiveInfo.split('-')[1] }}</div>
                            <div style="text-align: left">收款账号：{{ scope.row.recharge.receiveInfo.split('-')[2] }}</div>
                        </div>
                        <div v-else>
                            <el-image
                                @click='updateSrcList(scope.row.recharge.receiveInfo)'
                                style="width: 100px; height: 100px"
                                :src="scope.row.recharge.receiveInfo"
                                :preview-src-list="srcList">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="收款信息" width="300px">
                    <template slot-scope="scope" v-if='scope.row.recharge != null'>
                        <div>
                            {{scope.row.recharge.payInfo}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="收款凭证" width="150px">
                    <template slot-scope="scope" v-if='scope.row.recharge != null'>
                        <el-image
                            @click='updateSrcList(scope.row.recharge.payPic)'
                            style="width: 80px; height: 80px"
                            :src="scope.row.recharge.payPic"
                            :preview-src-list="srcList"
                        >
                        </el-image>
                    </template>
<!--                    <template slot-scope="scope" v-if='scope.row.recharge != null'>-->
<!--                        <div style=' width: 80px;height: 80px;margin: 0 auto'>-->
<!--                            <img :src='scope.row.recharge.payPic'>-->
<!--                        </div>-->
<!--                    </template>-->
                </el-table-column>
                <el-table-column align="center" label="记录类型" width="150px">
                    <template slot-scope="scope">
                        {{ getRecordStatus(scope.row.recordStatus) }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="创建时间" width="150px">
                    <template slot-scope="scope">
                        {{ scope.row.createTime }}
                    </template>
                </el-table-column>



                <el-table-column align="center" label="操作" width="150px">
                    <template slot-scope="scope">
                        <el-button type="primary" round size="mini" v-if="scope.row.recordStatus == 5" @click="examineButton(scope.row)"
                        >待审核</el-button>
<!--                        <div style='color: #F56C6C' v-if="scope.row.recordStatus == 7">未通过</div>-->
<!--                        <div style='color: #67C23A' v-if="scope.row.recordStatus == 6">完成</div>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>

            <!--审核功能-->
            <el-dialog title="资金充值审核" :visible.sync="retreatDialogVisible" width="30%" :before-close="handleCloseRetreat">
                <el-form ref="retreatForm" :rules="retreatRules" size="small" :model="retreatForm" label-width="100px">
                    <el-form-item label="是否同意：" prop="resource">
                        <el-radio-group v-model="retreatForm.resource">
                            <el-radio label="true">同意</el-radio>
                            <el-radio label="false">拒绝</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="拒绝原因：" v-if="retreatForm.resource == 'false'" prop="desc">
                        <el-input style="width: 100%" type="textarea" v-model="retreatForm.desc"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="handleCloseRetreat">取 消</el-button>
                  <el-button type="primary" @click="retreatSuccess('retreatForm')">确 定</el-button>
                </span>
            </el-dialog>

        </div>
    </div>
</template>
<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, get, post, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    data(){
        return{
            retreatDialogVisible:false,
            rechargeList:[],
            totalNum:0,
            pageSize: 10,
            currentPage: 1,
            timeRange: [],
            queryForm: {
                recordStatus: null, //记录状态
                currencyType: null, //目标类型
                userName: null,
                startTime: null,
                endTime: null,
                userMobile: '',
                userNickname: '',
                userRealname: ''
            },
            retreatRules: {
                resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
                desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }]
            },
            srcList:[''],
            retreatForm:{
                resource:'',
                desc:''
            },
            auditId:'',
            recordStatusList:[],
            currencyTypeList:[],
            isSearch:false, // 搜索按钮
        }
    },
    created() {
        this.getRechargeList()
        this.getRecordStatusList()
        this.getCurrencyTypeList()
    },
    methods:{
        getRechargeList(){
            this.loading = true;
            if (this.timeRange != null) {
                this.queryForm.startTime = this.timeRange[0];
                this.queryForm.endTime = this.timeRange[1];
            }
            get('/mpp/moneyrecord/findRechargeList',{
                ... this.queryForm,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then((res)=>{
                this.loading = false;
                if (res.success) {
                   this.rechargeList = res.page.list;
                    this.totalNum = res.page.total;
                    console.log('this.rechargeList',this.rechargeList)
                }
            })
        },

        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },

        sizeChange(size) {
            this.pageSize = size;
            this.getRechargeList();
        },

        currentChange(page) {
            this.currentPage = page;
            this.getRechargeList();
        },

        examineButton(item){
            this.auditId = item.id
            this.retreatDialogVisible = true;
        },

        // 审核取消按钮
        handleCloseRetreat() {
            this.retreatDialogVisible = false;
            this.auditId = ''//关闭后清除点击的id
            this.retreatForm.resource = ''//关闭后把选择的按钮置空
            this.retreatForm.desc = ''//关闭后把拒绝理由清空
        },

        retreatSuccess(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //处理选择同意&拒绝
                    let status = 5
                    this.retreatForm.resource == 'true' ? status = 6 : status = 7
                    this.retreatDialogVisible = false
                    get(`/mpp/moneyrecord/auditRecharge`,{
                        id:this.auditId,
                        status:status,
                        refuseReason:this.retreatForm.desc,
                    }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.getRechargeList();
                        }
                    });
                }
            })
        },

        //把点击的图片放在大图预览的位置
        updateSrcList(src){
            this.srcList[0] = src
        },

        //记录状态
        getRecordStatusList() {
            get(`/mpp/utils/getEnum`, { enumType: `money_record_status` }).then((res) => {
                if (res.success) {
                    this.recordStatusList = res.enumList;
                }
            });
        },

        //获取货币类型
        getCurrencyTypeList() {
            get(`/mpp/utils/getEnum`, { enumType: `currency_type` }).then((res) => {
                if (res.success) {
                    this.currencyTypeList = res.enumList;
                }
            });
        },

        getRecordStatus(recordStatus) {
            for (const index in this.recordStatusList) {
                if (this.recordStatusList[index].key == recordStatus) {
                    return this.recordStatusList[index].value;
                }
            }
        },

        getCurrencyType(type) {
            for (const index in this.currencyTypeList) {
                if (this.currencyTypeList[index].key == type) {
                    return this.currencyTypeList[index].value;
                }
            }
        },

        // 搜索按钮
        search() {
            this.isSearch = !this.isSearch;
        },

        // 查询
        searchRecordList() {
            this.getRechargeList();
        },

        // 重置
        resetDialog() {
            this.queryForm = {
                recordStatus: null, //记录状态
                currencyType: null, //目标类型
                userName: null,
                startTime: null,
                endTime: null,
                userMobile: '',
                userNickname: '',
                userRealname: ''
            };
            this.timeRange = [];
            this.getRechargeList();
        },

        /**
         * 导出充值明细信息
         */
        exportRecharge(){
            exprotExcel(`/finance/moneyrecord/exportRecharge`, { ...this.queryForm });
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.moneyRecord-table-expand {
    font-size: 0;
    margin-top: -20px;
}
.moneyRecord-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.moneyRecord-table-expand .el-form-item {
    margin-left: 4%;
    margin-bottom: -1%;
    width: 100%;
}
.sum {
    margin-left: 10px;
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #606266;
}
</style>
